import { __decorate } from "tslib";
import { attr } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { foundationGridLayoutItemTemplate as template } from './grid-layout-item.template';
export const foundationGridLayoutItemShadowOptions = undefined;
export const defaultGridLayoutItemConfig = {};
/**
 * @tagname %%prefix%%-grid-layout-item
 */
export class GridLayoutItem extends FoundationElement {
    setGridItemProperties(column, row, width, height) {
        if (row && column && width && height) {
            const gridRow = row === 0 || height === 0 ? 'auto' : `${row} / ${Number(row) + Number(height)}`;
            const gridColumn = column === 0 || width === 0 ? 'auto' : `${column} / ${Number(column) + Number(width)}`;
            return `grid-row: ${gridRow}; grid-column: ${gridColumn}`;
        }
    }
}
__decorate([
    attr({ attribute: 'col-number' })
], GridLayoutItem.prototype, "colNumber", void 0);
__decorate([
    attr({ attribute: 'col-sm-number' })
], GridLayoutItem.prototype, "colSmNumber", void 0);
__decorate([
    attr({ attribute: 'col-md-number' })
], GridLayoutItem.prototype, "colMdNumber", void 0);
__decorate([
    attr({ attribute: 'col-lg-number' })
], GridLayoutItem.prototype, "colLgNumber", void 0);
__decorate([
    attr({ attribute: 'row-number' })
], GridLayoutItem.prototype, "rowNumber", void 0);
__decorate([
    attr({ attribute: 'row-sm-number' })
], GridLayoutItem.prototype, "rowSmNumber", void 0);
__decorate([
    attr({ attribute: 'row-md-number' })
], GridLayoutItem.prototype, "rowMdNumber", void 0);
__decorate([
    attr({ attribute: 'row-lg-number' })
], GridLayoutItem.prototype, "rowLgNumber", void 0);
__decorate([
    attr({ attribute: 'width' })
], GridLayoutItem.prototype, "width", void 0);
__decorate([
    attr({ attribute: 'width-sm' })
], GridLayoutItem.prototype, "widthSm", void 0);
__decorate([
    attr({ attribute: 'width-md' })
], GridLayoutItem.prototype, "widthMd", void 0);
__decorate([
    attr({ attribute: 'width-lg' })
], GridLayoutItem.prototype, "widthLg", void 0);
__decorate([
    attr({ attribute: 'height' })
], GridLayoutItem.prototype, "height", void 0);
__decorate([
    attr({ attribute: 'height-sm' })
], GridLayoutItem.prototype, "heightSm", void 0);
__decorate([
    attr({ attribute: 'height-md' })
], GridLayoutItem.prototype, "heightMd", void 0);
__decorate([
    attr({ attribute: 'height-lg' })
], GridLayoutItem.prototype, "heightLg", void 0);
/**
 * The Foundation Grid Layout Item
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-grid-layout-item\>
 */
export const foundationGridLayoutItem = GridLayoutItem.compose(Object.assign({ baseName: 'grid-layout-item', template, shadowOptions: foundationGridLayoutItemShadowOptions }, defaultGridLayoutItemConfig));
